export class ArchiveFileReference {
    constructor(
        readonly id: number,
        readonly archiveId: number,
        readonly nameHash: number,
    ) {}
}
